import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryFeature from './components/CategoryFeature';
import CTAFeature from './components/CTAFeature';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryFeature />
        <CTAFeature />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "韩漫在线观看 - 漫画免费下拉式阅读 - 好看的韩国漫画全集 - 韩国漫画网",
          "description": "韩国漫画网提供韩漫在线观看服务，漫画免费下拉式阅读模式让您畅览好看的韩国漫画全集。",
          "url": "http://zhidavip.com/",
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩国漫画网",
            "url": "http://zhidavip.com/"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "http://zhidavip.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "热门韩漫推荐",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Article",
                "name": "秘密教学",
                "url": "http://zhidavip.com/comic/secret-class",
                "author": { "@type": "Person", "name": "作家Yoon" }
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Article",
                "name": "魔王归来",
                "url": "http://zhidavip.com/comic/demon-king",
                "author": { "@type": "Person", "name": "作家Kim" }
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Article",
                "name": "星光之恋",
                "url": "http://zhidavip.com/comic/star-romance",
                "author": { "@type": "Person", "name": "作家Jung" }
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "Article",
                "name": "格斗天王",
                "url": "http://zhidavip.com/comic/action-hero",
                "author": { "@type": "Person", "name": "作家Choi" }
              }
            }
          ]
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://zhidavip.com/" }
          ]
        })
      }} />
    </>
  );
}